import types from './types';
import initialState from './initialState';

export default (state = initialState, action) => {
  switch (action.type) {
    case types.CATEGORIES:
      return { ...state, ...{ categories: action.payload } };

    case types.SUB_CATEGORIES:
      return { ...state, ...{ subcategories: action.payload } };

    case types.SEARCH:
      return { ...state, ...{ search: action.payload } };

    case types.PUBLISHED_DATES:
      return { ...state, ...{ publishedDates: action.payload } };
    
    case types.DOCUMENT_TYPES: 
      return { ...state, ...{documentTypes: action.payload} };  

    case types.DOCUMENT_SOURCES: 
      return { ...state, ...{documentSources: action.payload} };  

    case types.MUNICIPALITY:
      return { ...state, ...{ municipality: action.payload } };

    case types.SORT:
      return { ...state, ...{ sort: action.payload } };

    case types.TABLE_ORDER:
      return { ...state, ...{ headerSort: action.payload } };


    case types.SET_LANGUAGE:
      return { ...state, ...{ lang: action.payload}};  
      
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/filters/reducers.js